<template>
  <div class="card-form">
    <el-row :gutter="10">
      <el-col :span="9">
        <page-org-table @orgRowChange="orgRowChange" />
      </el-col>
      <el-col :span="15">
        <page-dep-table :orgRow="orgRow" />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import PageOrgTable from './components/main/org-table'
import PageDepTable from './components/main/department-table'
export default {
  name: 'system-business',
  components: {
    PageOrgTable,
    PageDepTable
  },
  data() {
    return {
      orgRow: null,
    }
  },
  mounted() {},
  methods: {
    orgRowChange(data) {
      this.orgRow = data
    }
  },
}
</script>
